// extracted by mini-css-extract-plugin
module.exports = {"th":"movementsList_th__2UKL-","tr":"movementsList_tr__kRubS"};